import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import styles from "./CardDetailsModal.module.css";
import axios from "axios";

export default function MyVerticallyCenteredModal(props) {
  const [cardDetails, setCardDetails] = useState();
  const boardid = props.boardid;
  const columnid = props.columnid;
  const cardid = props.cardid;

  useEffect(() => {
    axios
      .get(
        `https://pro-organizer-app-7871e.firebaseio.com/${boardid}/ColumnList/${columnid}.json`
      )
      .then((res) => setCardDetails(res.data));
  }, [boardid, columnid]);

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={styles.Heading}
        >
          {cardDetails?.Cards[cardid].Title}
          <p className={styles.SubHeading}>in {cardDetails?.Column}</p>
        </Modal.Title>
        {/* <button
          style={{ marginRight: "5px", marginLeft: "10px" }}
          type="button"
          className="btn btn-primary"
        >
          Edit
        </button>
        &nbsp;
        <button
          style={{ float: "right" }}
          type="button"
          className="btn btn-danger"
        >
          Archive
        </button> */}
      </Modal.Header>
      <Modal.Body>
        <h5>Description</h5>
        <div>{cardDetails?.Cards[cardid].Description}</div>
        <hr></hr>
        <h5>Members</h5>
        <p>
          <span className={styles.Members}>
            {cardDetails?.Cards[cardid].Members.split("-")[0]}
          </span>
        </p>
        <hr></hr>
        <h5>Due Date</h5>
        <div>{cardDetails?.Cards[cardid].Due_Date}</div>
      </Modal.Body>
    </Modal>
  );
}
